import { render, staticRenderFns } from "./BomDetail.vue?vue&type=template&id=717be03c"
import script from "./BomDetail.vue?vue&type=script&lang=js"
export * from "./BomDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports